<template>
  <SearchFormWrapper>
    <form
      autocomplete="off"
      class="flex items-center gap-2"
      @submit.prevent="$emit('search', JSON.parse(JSON.stringify(searchParams)))"
    >
      <SearchQueryTextInput v-model="searchParams.search" />

      <SwitchInputWrapper>
        <SwitchInput
          v-model="searchParams.includeArchived"
          text="Show Archived"
        />
      </SwitchInputWrapper>

      <SearchButton />
    </form>
  </SearchFormWrapper>
</template>

<script setup>
import { ref } from 'vue';
import { SearchFormWrapper } from '@/components/forms';
import { SearchButton } from '@/components/buttons/index.js';
import { SearchQueryTextInput, SwitchInput } from '@/components/form-inputs/index.js';
import { SwitchInputWrapper } from '@/components/wrappers/index.js';

defineEmits(['search']);

const searchParams = ref({
  search: null,
  includeArchived: false,
});
</script>
